import { memo } from 'react';
import { Box, Text, Pressable } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IFeedbackItemProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

const FeedbackItemComponent = ({ label, isSelected, onClick }: IFeedbackItemProps) => (
  <Pressable key={label} onPress={onClick}>
    <Box
      minWidth={206}
      borderRadius={24}
      backgroundColor={isSelected ? Colors.primary_50 : Colors.white}
      border={`1.5px solid ${isSelected ? Colors.secondary_500 : Colors.neutral_100}`}
      style={{ cursor: 'pointer' }}
    >
      <Text paddingBlock={8} paddingInline={20}>
        {label}
      </Text>
    </Box>
  </Pressable>
);

export const FeedbackItem = memo(FeedbackItemComponent);
